// extracted by mini-css-extract-plugin
export default {"inputLabel":"Label_inputLabel__EvwSO","noMarginBottom":"Label_noMarginBottom__bKGZG","mandatoryAsterisk":"Label_mandatoryAsterisk__10p0y"};